import styled from 'styled-components';
import { ToastContainer as Toast } from 'react-toastify';

const ToastContainer = styled(Toast)`
  .Toastify__toast:has(.info-toast) {
    background-color: #3498db;
    color: #fff;
    svg > path {
      fill: #fff;
    }

    .Toastify__progress-bar {
      background: #fff;
    }
  }
`;

export default ToastContainer;
